import type {
  ApiEventId,
  ApiInternshipId,
  ApiJobId,
  ApiOrgId,
  ApiVolopId,
} from '#/api/types/ApiTypedId';
import {
  orgDashboardViewEventRoute,
  orgDashboardViewInternshipRoute,
  orgDashboardViewJobRoute,
  orgDashboardViewVolopRoute,
} from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { ListingType } from '#/types/ListingType';

type Args = {
  orgId: ApiOrgId;
  listingId: ApiJobId | ApiInternshipId | ApiVolopId | ApiEventId;
  listingType: Exclude<ListingType, 'ORG'>;
};

export function orgDashboardGetViewListingPathSwitch({
  orgId,
  listingId,
  listingType,
}: Args) {
  switch (listingType) {
    case 'JOB':
      return orgDashboardViewJobRoute.with({ orgId, jobId: listingId });
    case 'INTERNSHIP':
      return orgDashboardViewInternshipRoute.with({
        orgId,
        internshipId: listingId,
      });
    case 'VOLOP':
      return orgDashboardViewVolopRoute.with({
        orgId,
        volopId: listingId,
      });
    case 'EVENT':
      return orgDashboardViewEventRoute.with({
        orgId,
        eventId: listingId,
      });
  }
}
